/** Format active-offer distanceMeters (meters, not km). */
export function formatDistanceToPickup(
  meters: number | null | undefined,
): string {
  if (meters == null || !Number.isFinite(meters)) return '—';
  const m = Math.max(0, Math.round(meters));
  if (m < 1000) return `${m} m`;
  const km = m / 1000;
  return km < 10 ? `${km.toFixed(1)} km` : `${Math.round(km)} km`;
}
